export enum PerformanceProReportQueryNames {
  GetReport = "report",
}

export enum SettingsQueryNames {
  GetBreakTimes = "break-times",
}
